export default __webpack_public_path__ + "static/media/koehn.eae6ea2c.jpeg";